import { render, staticRenderFns } from "./GenerateInvoice.vue?vue&type=template&id=ecb6aace&scoped=true&"
import script from "./GenerateInvoice.vue?vue&type=script&lang=js&"
export * from "./GenerateInvoice.vue?vue&type=script&lang=js&"
import style0 from "./GenerateInvoice.vue?vue&type=style&index=0&id=ecb6aace&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb6aace",
  null
  
)

export default component.exports